import { api } from '../core';

export type DocumentCreateResponse = {
  documentId: string;
};

type DocumentCreateProps = {
  abortController?: AbortController;
  caseId: string;
  documentName: string;
  documentSizeMb: number;
};

const documentCreateApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postDocumentCreate: builder.query<DocumentCreateResponse, DocumentCreateProps>({
      query: ({
        abortController = new AbortController(),
        caseId,
        documentName,
        documentSizeMb
      }: DocumentCreateProps) => ({
        url: `document/create`,
        method: 'POST',
        body: {
          case_id: caseId,
          document_name: documentName,
          document_size_mb: documentSizeMb
        },
        signal: abortController.signal
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in postDocumentCreate in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostDocumentCreateQuery } = documentCreateApi;
